import React from 'react';
import './NeedHelp.scss';
import { Button, Grid } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const NeedHelp: React.FC = () => {
  const { t } = useTranslation('common');
  const screens = Grid.useBreakpoint();

  const handleClickHere = () => {
    const phoneNumber = '85295416079';
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  };

  return (
    <div className="help-section">
      *{t('needHelp.needHelp')}{' '}
      {screens.xs ? '\n' : ' '}
      {t('needHelp.simply')}{' '}
      <Button onClick={handleClickHere} className="help-link" type="link">
        {t('needHelp.clickHere')}
      </Button>{' '}
      {t('needHelp.orContactUs')} 9541 6079{' '}
      <WhatsAppOutlined className="whatsapp-icon" />
    </div>
  );
};

export default NeedHelp;

